import { Version } from '@davesa/version/version';

export const DAVESA_VERSION = new Version('3.0.0').full;
